import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { getTokenCookies, getTokens, UserWithSmopDetails } from "@saleor/auth";
import { useSavedAccount } from "@saleor/components/AppLayout/SavedAccountContext";
import { IS_TOKEN_FROM_COOKIES } from "@saleor/config";
import React from "react";

import useStyles from "./styles";

export interface SaveAccountDialogProps {
  user: UserWithSmopDetails;
}

const syncSavedAccounts = () => {
  const sessionStorageAccounts = window.sessionStorage.getItem("savedAccounts");
  if (sessionStorageAccounts) {
    window.localStorage.setItem("savedAccounts", sessionStorageAccounts);
    window.sessionStorage.removeItem("savedAccounts");
  }
};

const SaveAccountDialog: React.FC<SaveAccountDialogProps> = ({ user }) => {
  const classes = useStyles({});
  syncSavedAccounts();

  const {
    ignoredAccounts,
    setIgnoredAccounts,
    setShowSaveAccountDialog,
    showSaveAccountDialog,
    handleAddSavedAccount
  } = useSavedAccount();

  const handleClose = () => {
    if (!ignoredAccounts.includes(user.email)) {
      setIgnoredAccounts([...ignoredAccounts, user.email]);
    }
    setShowSaveAccountDialog(false);
  };

  const handleSaveAccount = () => {
    const { auth, csrf } = IS_TOKEN_FROM_COOKIES
      ? getTokenCookies()
      : getTokens();

    handleAddSavedAccount({
      csrf,
      email: user.email,
      firstName: user.firstName,
      lastLogin: Date.now(),
      lastName: user.lastName,
      token: auth
    });

    setShowSaveAccountDialog(false);
  };

  return (
    <Dialog
      open={showSaveAccountDialog}
      maxWidth="sm"
      classes={{
        paper: classes.dialog
      }}
    >
      <DialogHeader handleClose={handleClose} />
      <DialogContent className={classes.content}>
        <Typography component="p">
          Do you want to save your account for future transactions with us?
        </Typography>
      </DialogContent>
      <DialogFooter
        handleClose={handleClose}
        handleSaveAccount={handleSaveAccount}
      />
    </Dialog>
  );
};

interface DialogHeaderProps {
  handleClose: () => void;
}

const DialogHeader: React.FC<DialogHeaderProps> = ({ handleClose }) => {
  const classes = useStyles({});

  return (
    <DialogTitle className={classes.title}>
      <Box className={classes.titleWrapper}>
        <Typography className={classes.titleText} component="span">
          Save Account
        </Typography>
        <IconButton className={classes.closeIcon} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
  );
};

interface DialogFooterProps {
  handleClose: () => void;
  handleSaveAccount: () => void;
}

const DialogFooter: React.FC<DialogFooterProps> = ({
  handleClose,
  handleSaveAccount
}) => {
  const classes = useStyles({});
  return (
    <DialogActions className={classes.actions}>
      <Button
        id="btnNoThanks"
        className={classes.noThanksButton}
        onClick={handleClose}
      >
        NO, THANKS
      </Button>

      <Button
        id="btnSaveAccount"
        className={classes.saveAccountButton}
        variant="contained"
        onClick={handleSaveAccount}
      >
        SAVE ACCOUNT
      </Button>
    </DialogActions>
  );
};

SaveAccountDialog.displayName = "SaveAccountDialog";
export default SaveAccountDialog;
